import { ConcreteEncodable } from "./ConcreteEncodable";

import { OpsFiltCategoryTypeImplEncoder } from "../../encoder/OpsFiltCategoryTypeImplEncoder";

import * as CubiqTS from "../../index";
import { OpsFiltCategoryType } from "../OpsFiltCategoryType";

export class OpsFiltCategoryTypeImpl extends ConcreteEncodable implements OpsFiltCategoryType {
  public static enType: string = "com.bcdfx.model.opsfilters.OpsFiltCategoryTypeImpl";

  /*FID=1*/
  public filterCategoryId: string;
  /*FID=2*/
  public filterCatDesc: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OpsFiltCategoryTypeImplEncoder.Instance;
    this.setEncodableType(OpsFiltCategoryTypeImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OpsFiltCategoryTypeImpl[" +
      "filterCategoryId=" +
      this.filterCategoryId +
      "filterCatDesc=" +
      this.filterCatDesc +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
